import React, { useState } from 'react'
import type { TabsChild, TabsMethodsResult, TabsProps } from './tabs.types'

const getTabs = (children: React.ReactNode): TabsChild[] =>
    React.Children.toArray(children).filter((child): child is TabsChild => React.isValidElement(child))

const TabsMethods = (p_: TabsProps): TabsMethodsResult => {
    const tabs = getTabs(p_.children)
    const [active, setActive] = useState<string>(p_.active || (tabs[0] ? tabs[0].props.tabid : ''))

    const getTabFromId = (tabid: string) => {
        return tabs.find((child) => child.props.tabid === tabid)
    }
    const onClick = (tab: string) => {
        setActive(tab)
        p_.onChange(tab)
    }

    return {
        active,
        tabs,
        onClick,
        getTabFromId,
    }
}

export default TabsMethods
